import { useTheme } from "@/app/providers/theme-provider"
import { Moon, Sun } from "@/components/icons"
import { Switch } from "@/components/ui/switch"

export function ThemeSwitcher() {
  // Reflect what is painted: under "system" the page may already be dark, and
  // the first click must flip away from that, not to it.
  const { setTheme, resolvedTheme } = useTheme()

  function handleCheckedChange(checked: boolean) {
    setTheme(checked ? "dark" : "light")
  }

  return (
    <section className="relative w-min">
      <Switch
        checked={resolvedTheme === "dark"}
        className="data-[state=checked]:bg-primary data-[state=unchecked]:bg-primary h-7 w-[52px]"
        thumbClassName="size-[22px] data-[state=checked]:translate-x-6"
        onCheckedChange={handleCheckedChange}
      />
      <Sun className="text-primary-foreground pointer-events-none absolute top-1/2 right-[9%] size-[1.2rem] translate-y-[-60%] scale-100 rotate-0 opacity-100 transition-[scale,rotate,opacity] dark:scale-75 dark:-rotate-90 dark:opacity-0" />
      <Moon className="text-primary-foreground pointer-events-none absolute top-1/2 left-[5%] size-[1.2rem] translate-y-[-60%] scale-75 rotate-90 opacity-0 transition-[scale,rotate,opacity] dark:scale-100 dark:rotate-0 dark:opacity-100" />
    </section>
  )
}
